<template>
  <div class="section-wrap" id="basic-modal-template">
    <h3 class="section-title mt-40"><label for="resume-title">이력서 제목</label></h3>
    <div class="input-area mt-16">
      <input v-model="basic.title" type="text" placeholder="이력서 제목을 입력하세요" id="resume-title" title="이력서 제목을 입력하세요" @input="limitBytes($event, basic, 'title', 200, '이력서 제목')" />
    </div>
    <h3 class="section-title mt-40">구직자 기본정보</h3>
    <div class="table-wrap mt-16">
      <table class="table-body-only">
        <caption class="ir-text">개인정보입력</caption>
        <colgroup class="pc-cell">
          <col style="width: 160px" />
          <col />
        </colgroup>
        <colgroup class="mo-cell">
          <col style="width: 88px" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">이름</th>
            <td>{{ basic.indnm }}</td>
          </tr>
          <tr>
            <th scope="row">생년월일</th>
            <td>{{ basic.birthdyYear }}.{{ basic.birthdyMonth }}.{{ basic.birthdyDay }}</td>
          </tr>
          <tr>
            <th scope="row">성별</th>
            <td>
              <div class="flex gap10">
                <label class="radio-item">
                  <input type="radio" name="gender" value="M" checked="" v-model="basic.gender" title="남자 선택">
                  <span class="custom-radio"></span>
                  남자
                </label>
                <label class="radio-item">
                  <input type="radio" name="gender" value="F" v-model="basic.gender" title="여자 선택">
                  <span class="custom-radio"></span>
                  여자
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">휴대<br class="mo-only">전화번호<span class="must">*</span> </th>
            <td>
              <div class="input-group phone-group">
                <div class="items1">
                  <div class="input-area wid120">
                    <select title="휴대전화 앞자리 선택" v-model="basic.hp1">
                      <option v-for="(p, index) in moPhone1" :key="index" :value="p">{{ p }}</option>
                    </select>
                  </div>
                  <div class="dash">-</div>
                </div>
                <div class="items2">
                  <div class="input-area wid120">
                    <input type="text" placeholder="1234" title="전화번호 중간자리" v-model="basic.hp2" maxlength="4">
                  </div>
                  <div class="dash">-</div>
                  <div class="input-area wid120">
                    <input type="text" placeholder="1234" title="전화번호 뒷자리" v-model="basic.hp3" maxlength="4">
                  </div>
                </div>
              </div>
              <span>※ 사업신청정보, 심사, 활동정보 등이 발송될 수 있으므로 반드시 정확히 입력해주세요.</span>
            </td>
          </tr>
          <tr>
            <th scope="row">비상<br class="mo-only">연락처</th>
            <td>
              <div class="input-group phone-group">
                <div class="items1">
                  <div class="input-area wid120">
                    <select title="비상연락처 앞자리 선택" v-model="basic.tel1">
                      <option v-for="(p, index) in phone1" :key="index" :value="p">{{ p }}</option>
                    </select>
                  </div>
                <div class="dash">-</div>
                </div>
                <div class="items2">
                  <div class="input-area wid120">
                    <input type="text" placeholder="1234" title="전화번호 중간자리" v-model="basic.tel2" maxlength="4" @input="limitBytes($event, basic, 'tel2', 4, '비상연락처', 4)">
                  </div>
                  <div class="dash">-</div>
                  <div class="input-area wid120">
                    <input type="text" placeholder="1234" title="전화번호 뒷자리" v-model="basic.tel3" maxlength="4" @input="limitBytes($event, basic, 'tel3', 4, '비상연락처', 4)">
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">이메일<span class="must">*</span> </th>
            <td>
              <div class="input-group email-group">
                <div class="items1">
                  <div class="input-area wid200">
                    <input type="text" placeholder="1234" v-model="email1" title="이메일 계정" @input="limitBytes($event, $data, 'email1', 99 - getByteLength(emailEtc), '이메일', 99 - getByteLength(emailEtc))">
                  </div>
                  <div class="dash">@</div>
                </div>
                <div class="items2">
                  <div class="input-area wid200">
                    <select title="이메일 도메인 선택" v-model="email2">
                      <option value="">이메일 도메인 선택</option>
                      <option v-for="(item, index) in emailList" :key="index" :value="item">{{ item }}</option>
                    </select>
                  </div>
                  <div class="input-area wid200">
                    <input type="text" placeholder="email.com" v-model="emailEtc" :disabled="email2 !== '직접입력'" title="이메일 도메인 직접이력" @input="limitBytes($event, $data, 'emailEtc', 99 - getByteLength(email1), '이메일', 99 - getByteLength(email1))">
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">주소<span class="must">*</span> </th>
            <td>
              <div class="address-wrap">
                <div class="input-group post-code">
                  <div class="input-area wid200">
                    <input type="text" placeholder="" v-model="basic.zipcode" readonly title="우편번호">
                  </div>
                  <button type="button" class=" btn btn-primary btn-xsm" @click="findAddress">
                    우편번호 검색
                  </button>
                </div>
                <div class="input-area">
                  <div id="searchPostCodeWrap" style="display:none;border:1px solid;width:500px;height:300px;margin:5px 0;position:relative; overflow: hidden;">
                    <img src="//t1.daumcdn.net/localimg/localimages/07/postcode/320/close.png" id="btnFoldWrap" style="cursor:pointer;position:absolute;right:0px;top:-1px;z-index:1" alt="접기 버튼" @click="foldDaumPostcode">
                  </div>
                </div>
              </div>
              <div class="address-wrap">
                <div class="input-group add-input">
                  <div class="input-area wid400">
                    <input type="text" disabled placeholder="" v-model="basic.addr" title="주소">
                  </div>
                  <div class="input-area wid400">
                    <input type="text" placeholder="" v-model="basic.addrDtl" title="상세 주소" @input="limitBytes($event, basic, 'addrDtl', 1000, '상세 주소')">
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
</template>

<script>
/* global daum */
import Axios from 'axios';
import { apiHandler, byteUtil, byteLimitMixin } from './resume-common';
import addressMixin from '../mixins/addressMixin';

const moPhone1 = [
  '010', '011', '016', '017', '018', '019',
];

const phone1 = [
  '02', '031', '032', '033', '041', '042', '043', '044',
  '051', '052', '053', '054', '055', '061', '062', '063',
  '064', '070', '010', '011', '016', '017', '018', '019',
];

const emailList = [
  'naver.com',
  'hanmail.net',
  'daum.net',
  'gmail.com',
  'google.com',
  'nate.com',
  'yahoo.com',
  'paran.com',
  'korea.com',
  'freechal.com',
  '직접입력',
];

export default ({
  name: 'basic-modal-template',
  mixins: [addressMixin, byteLimitMixin],
  props: ['basicModal', 'resume'],
  data() {
    return {
      indbankNo: this.resume.indbankNo,
      basic: {
        title: '',
        indnm: '',
        birthdyYear: '',
        birthdyMonth: '',
        birthdyDay: '',
        gender: '',
        hp1: '',
        hp2: '',
        hp3: '',
        tel1: '',
        tel2: '',
        tel3: '',
        email: '',
        zipcode: '',
        addr: '',
        addrDtl: '',
        resumeTitle: '',
      },
      moPhone1,
      phone1,
      emailList,
      email1: '',
      email2: '',
      emailEtc: '',
    };
  },
  watch: {
    basicModal: {
      handler(newVal) {
        if (newVal) {
          if (this.resume.indbankNo) this.getBasic();
          else this.getMemberInfo();
        }
      },
      immediate: true,
    },
    email2: {
      handler(newVal) {
        if (newVal !== '직접입력') this.emailEtc = newVal;
      },
    },
  },
  methods: {
    getMemberInfo() {
      Axios.get('/api/idb/member-info').then((response) => {
        if (response.data.success === 'R') {
          const data = response.data.data;
          const birthdy = this.formatBirthDate(data.birthdate);
          this.basic = {
            ...data,
            indnm: data.indNm,
            ...birthdy,
          };
          this.getEmail();
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    getBasic() {
      Axios.get(`/api/idb/${this.resume.indbankNo}/basic`).then((response) => {
        if (response.data.success === 'R') {
          this.basic = response.data.data;
          this.getEmail();
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    async updateBasic() {
      this.basic.resumeTitle = this.basic.title;
      this.basic.email = `${this.email1}@${this.emailEtc}`;

      if (!this.vaildCheck()) {
        return;
      }

      if (!confirm('저장 하시겠습니까?')) {
        return;
      }

      // indbankNo가 없는 경우 먼저 이력서 생성
      if (!this.indbankNo) {
        try {
          await this.createResume();
        } catch (error) {
          return; // 이력서 생성 실패 시 중단
        }
      }

      // 기본정보 업데이트
      Axios.post(`/api/idb/${this.indbankNo}/basic`, this.basic).then((response) => {
        const vm = this; // Vue 인스턴스 참조 저장
        apiHandler.handleSaveSuccess(response, (res) => {
          // 완성도 업데이트 (올바른 경로로 접근)
          if (res.data && res.data.data.completionRate !== undefined) {
            vm.$emit('update:CompletionRate', res.data.data.completionRate);
          }
        });
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    async createResume() {
      if (!this.indbankNo) {
        try {
          const response = await Axios.post('/api/idb/create', this.basic);
          if (response.data.success === 'C') {
            const data = response.data.data;
            this.indbankNo = data.indbankNo;
            this.resume = {
              ...data,
            };
            this.$emit('update:resume', this.resume);
            this.$emit('update:CompletionRate', data.completionRate);
            this.$emit('update:indbankNo', data.indbankNo);
          }
        } catch (e) {
          apiHandler.handleError(e);
          throw e; // 에러를 다시 던져서 호출하는 곳에서 처리할 수 있도록 함
        }
      }
    },
    vaildCheck() {
      if (!this.basic.resumeTitle) {
        alert('이력서 제목을 입력해주세요.');
        return false;
      }
      if (!this.basic.hp1 || !this.basic.hp2 || !this.basic.hp3) {
        alert('휴대전화번호를 입력해주세요.');
        return false;
      }
      if (!this.integerFormmatter(this.basic.hp2) || !this.integerFormmatter(this.basic.hp3)) {
        alert('휴대전화번호는 숫자만 입력해주세요.');
        return false;
      }
      if (this.basic.hp2.length !== 4 || this.basic.hp3.length !== 4) {
        alert('입력하신 휴대전화번호가 4자리가 아닙니다.');
        return false;
      }
      if (!this.email1 || !this.emailEtc) {
        alert('이메일을 입력해주세요.');
        return false;
      }
      if (this.getByteLength(this.basic.email) > 100) {
        alert('이메일: 최대 100글자');
        return false;
      }
      if (!this.basic.zipcode || !this.basic.addr || !this.basic.addrDtl) {
        alert('주소를 입력해주세요.');
        return false;
      }
      return true;
    },
    getEmail() {
      if (!this.basic || !this.basic.email) {
        this.email1 = '';
        this.email2 = '';
        this.emailEtc = '';
      } else {
        const emailArray = this.basic.email.split('@');
        this.email1 = emailArray[0];
        this.email2 = '';
        this.emailEtc = '';

        emailList.forEach((email) => {
          if (email === emailArray[1]) {
            this.email2 = email;
            this.emailEtc = email;
          }
        });

        if (this.email2 === '') {
          this.email2 = '직접입력';
          this.emailEtc = emailArray[1];
        }
      }
    },
    getByteLength(str) {
      return byteUtil.getByteLength(str);
    },
    integerFormmatter(txt) {
      const idReg = /^[0-9]+$/;
      return idReg.test(txt);
    },
    formatBirthDate(birthdate) {
      if (!birthdate || birthdate.length !== 6) {
        return birthdate;
      }

      // YYMMDD -> YYYY, MM, DD
      const [, yy, mm, dd] = birthdate.match(/(\d{2})(\d{2})(\d{2})/);
      console.log(yy, mm, dd);

      return { birthdyYear: `19${yy}`, birthdyMonth: mm, birthdyDay: dd };
    },
    foldDaumPostcode() {
      const elementWrap = document.getElementById('searchPostCodeWrap');
      // iframe을 넣은 element를 안보이게 한다.
      elementWrap.style.display = 'none';
    },
    findAddress() {
      const thisVal = this;
      const elementWrap = document.getElementById('searchPostCodeWrap');
      // 현재 scroll 위치를 저장해놓는다.
      const currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      daum.postcode.load(() => {
        new daum.Postcode({
          oncomplete(data) {
            // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

            // 각 주소의 노출 규칙에 따라 주소를 조합한다.
            // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
            let fullAddr = data.address; // 최종 주소 변수
            let extraAddr = ''; // 조합형 주소 변수

            // 기본 주소가 도로명 타입일때 조합한다.
            if (data.addressType === 'R') {
              // 법정동명이 있을 경우 추가한다.
              if (data.bname !== '') {
                extraAddr += data.bname;
              }
              // 건물명이 있을 경우 추가한다.
              if (data.buildingName !== '') {
                extraAddr += (extraAddr !== '' ? `,${data.buildingName}` : data.buildingName);
              }
              // 조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종 주소를 만든다.
              fullAddr += (extraAddr !== '' ? `(${extraAddr})` : '');
            }

            // 우편번호와 주소 정보를 해당 필드에 넣는다.
            // 5자리 새우편번호 사용
            // document.getElementById('postcode').value = data.zonecode;
            thisVal.basic.addr = fullAddr;
            thisVal.basic.zipcode = data.zonecode;

            // iframe을 넣은 element를 안보이게 한다.
            // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
            elementWrap.style.display = 'none';

            // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
            document.body.scrollTop = currentScroll;
          },
          // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
          onresize(size) {
            elementWrap.style.height = `${size.height}px`;
          },
          width: '100%',
          height: '100%',
        }).embed(elementWrap);
      });
      // iframe을 넣은 element를 보이게 한다.
      elementWrap.style.display = 'block';
    },
  },
  mounted() {
  },
});
</script>



// WEBPACK FOOTER //
// Basic.vue?5963f1dc